import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';



  

@Injectable()
export class InventoryService {

    callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
         
           this.callurl=_global.baseAPIUrl; 
         }

         
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=9)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }
        
         saveinvmitem(empdata: any): Observable<any> {

          empdata.clcd=this.clcd;
          empdata.aycd=this.aycd;
           empdata.usid=this.usid;
    return this.http.post(this._global.baseAPIUrl + 'saveinvmitem', empdata)
        .pipe(map((data: any) => {
            console.log('retres', data);
            return data;
        }));
}

saveinvqritem(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
  empdata.usid=this.usid;
return this.http.post(this._global.baseAPIUrl + 'saveinvqritem', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}


getinvqritem(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvqritem', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invqritem;
          
      }));
} 


getinvmitem(): Observable<any> {
    debugger
    // let clcd=localStorage.getItem('clcd');
    // let aycd=localStorage.getItem('aycd');
    let postdat={clcd:this.clcd,aycd:this.aycd}
    return this.http.post(this.callurl + 'getinvmitem', postdat)
    .pipe(map((data: any) => {
            console.log('retres', data);
            return data.invmitem;
            
        }));
} 

getinvmiga(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmiga', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmiga;
          
      }));
} 

saveinvmiga(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmiga', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}
getinvmigb(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmigb', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmigb;
          
      }));
} 

saveinvmigb(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
  empdata.crby=this.usid;
return this.http.post(this._global.baseAPIUrl + 'saveinvmigb', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}

getinvmasset(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmasset', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmasset;
          
      }));
} 
    
saveinvmasset(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmasset', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}


getinvmbrand(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmbrand', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmbrand;
          
      }));
} 


saveinvmbrand(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmbrand', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}

getinvmmfr(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmmfr', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmmfr;
          
      }));
} 
  
saveinvmmfr(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmmfr', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}
getinvmmnttype(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmmnttype', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmmnttype;
          
      }));
} 


saveinvmmnttype(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmmnttype', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}
getinvmstcat(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmstcat', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmstcat;
          
      }));
}


saveinvmstcat(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmstcat', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}
getinvmstore(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmstore', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmstore;
          
      }));
}

saveinvmstore(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmstore', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}

getinvmunit(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmunit', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmunit;
          
      }));
}

saveinvmunit(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
return this.http.post(this._global.baseAPIUrl + 'saveinvmunit', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}

getinvmsplr(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmsplr', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmsupl;
          
      }));
}


saveinvmsplr(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
    empdata.usid=this.usid;
return this.http.post(this._global.baseAPIUrl + 'saveinvmsplr', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}


getinvmtaxslab(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvmtaxslab', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invmunit;
          
      }));
}


getinvtisutmph(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  return this.http.post(this.callurl + 'getinvtisutmph', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invqritem;
          
      }));
}

getinvtisutmpd(isid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd,istpid:isid}
  return this.http.post(this.callurl + 'getinvtisutmpd', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invtisutmpd;
          
      }));
}


saveinvtisutmph(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
    empdata.usid=this.usid;
return this.http.post(this._global.baseAPIUrl + 'saveinvtisutmph', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}

saveinvtisutmpd(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
    empdata.usid=this.usid;
return this.http.post(this._global.baseAPIUrl + 'saveinvtisutmpd', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}



getinvstusale(srctxt): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd,srctxt:srctxt}
  console.log('postdat', postdat);
  return this.http.post(this.callurl + 'getinvstusale', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.invstusale;
          
      }));
}


saveinvtgrn(empdata: any): Observable<any> {

  empdata.clcd=this.clcd;
  empdata.aycd=this.aycd;
    empdata.usid=this.usid;
return this.http.post(this._global.baseAPIUrl + 'saveinvtgrn', empdata)
.pipe(map((data: any) => {
    console.log('retres', data);
    return data;
}));
}


getinvh(): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd}
  console.log('postdat', postdat);
  return this.http.post(this.callurl + 'getinvtgrnh', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data.arrinvh;
          
      }));
}
getinvgrn(grnid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd,grnid:grnid}
  console.log('postdat', postdat);
  return this.http.post(this.callurl + 'getinvtgrndet', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

delgrnd(grnid): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  let postdat={clcd:this.clcd,aycd:this.aycd,grid:grnid}
  console.log('postdat', postdat);
  return this.http.post(this.callurl + 'delgrnd', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}

updgrnd(postdat): Observable<any> {
  debugger
  // let clcd=localStorage.getItem('clcd');
  // let aycd=localStorage.getItem('aycd');
  // let postdat={clcd:this.clcd,aycd:this.aycd,grid:grnid}
  // console.log('postdat', postdat);
  postdat.clcd=this.clcd;
  postdat.aycd=this.aycd; 
  postdat.usid=this.usid;
  return this.http.post(this.callurl + 'updgrnd', postdat)
  .pipe(map((data: any) => {
          console.log('retres', data);
          return data;
          
      }));
}
}